"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const utils_1 = require("./utils");
const index_1 = require("../index");
class TimeZoneSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearchFocused: false,
            timeZoneSearch: '',
        };
        this.getFilteredTimeZones = this.getFilteredTimeZones.bind(this);
    }
    getFilteredTimeZones() {
        const { timeZoneSearch } = this.state;
        return Object.values(utils_1.timeZoneMap).filter(name => name.toLowerCase().includes(timeZoneSearch.toLowerCase()) || timeZoneSearch === '');
    }
    render() {
        const { device, selectorAnimationDirection, value, selectedValueIndex, onSelect } = this.props;
        const selectedValue = selectedValueIndex === undefined ? value : value[selectedValueIndex];
        const { isSearchFocused, timeZoneSearch } = this.state;
        return (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                position: 'absolute',
                top: 56,
                left: 0,
                zIndex: 3,
                width: device === 'Mobile' ? '100%' : 384,
                height: device === 'Mobile' ? '100%' : 378,
                background: index_1.white,
                animation: `${selectorAnimationDirection} 150ms ease-in-out`,
            } },
            React.createElement(index_1.PopoverSearch, { device: device, isSearchFocused: isSearchFocused, removeFocus: () => this.setState({ isSearchFocused: false }), setFocus: () => this.setState({ isSearchFocused: true }), submitText: (timeZoneSearch) => this.setState({ timeZoneSearch }), text: timeZoneSearch }),
            React.createElement("div", { style: {
                    height: '100%',
                    overflowY: 'scroll',
                } },
                React.createElement("div", { style: {
                        flex: '1 1 auto',
                        paddingBottom: device === 'Mobile' ? 56 : 0,
                    } },
                    React.createElement(index_1.SelectableList, { device: device }, this.getFilteredTimeZones().map((name, index) => (React.createElement("div", { key: index, style: {
                            alignItems: 'center',
                            display: 'flex',
                            minHeight: device === 'Mobile' ? 72 : 56,
                            justifyContent: 'space-between',
                            width: '100%',
                        }, onClick: () => {
                            if (selectedValueIndex === undefined) {
                                onSelect(utils_1.updateTimeZoneOfDateTime(value, name));
                            }
                            else {
                                const tempDates = [...value].map(d => utils_1.updateTimeZoneOfDateTime(d, name));
                                onSelect(tempDates);
                            }
                        } },
                        React.createElement(index_1.Text, { text: name, size: device === 'Mobile' ? 'large' : 'medium', textStyle: {
                                padding: device === 'Mobile' ? '24px 0' : '16px 0',
                            } }),
                        React.createElement(index_1.RadioButton, { selected: utils_1.getDisplayTimeZone(selectedValue) === name, style: {
                                outerStyle: {
                                    height: 18,
                                    width: 18,
                                },
                            } })))))))));
    }
}
exports.default = TimeZoneSelector;
